import { useCallback } from 'react';

import { useStorageState } from '@/hooks/use-storage-state';

const STORAGE_KEY = 'pref.envelopeRotate180';

/**
 * Device-local preference: rotate the printed #10 envelope 180° so the address
 * feeds right-side-up. Envelope feed orientation is printer-specific, so this is
 * a per-device toggle (mirrors {@link useDashboardTasks}) rather than a per-user
 * account setting. Off by default.
 */
export function useEnvelopeRotation(): {
	rotate: boolean;
	isLoading: boolean;
	setRotate: (value: boolean) => void;
	} {
	const [[isLoading, raw], setValue] = useStorageState(STORAGE_KEY);

	const setRotate = useCallback((value: boolean) => {
		setValue(value ? 'true' : null);
	}, [setValue]);

	return {
		rotate: raw === 'true',
		isLoading,
		setRotate,
	};
}
